import React, { useEffect } from "react";
import PropTypes from "prop-types";

const ServerUnavailable = ({ onRetry }) => {
    useEffect(() => {
        onRetry();
        const retryInterval = window.setInterval(onRetry, 5 * 1000);

        return () => window.clearInterval(retryInterval);
    }, [onRetry]);

    return (
        <main className="flex min-h-screen items-center justify-center bg-navy px-4 py-12 text-center text-white">
            <div className="w-full max-w-2xl">
                <p className="mb-5 text-sm font-semibold tracking-[0.35em] text-yellow-400">
                    ERROR 503
                </p>
                <h1 className="mb-6 font-display text-4xl font-bold sm:text-5xl">
                    SERVICE UNAVAILABLE
                </h1>
                <p className="mx-auto mb-10 max-w-xl text-base leading-relaxed text-white/80 sm:text-lg">
                    We can&apos;t connect to the server right now. The service may
                    be temporarily offline or undergoing maintenance. Please
                    try again in a moment.
                </p>
                <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
                    <button
                        type="button"
                        onClick={onRetry}
                        className="min-w-40 rounded-full bg-white px-8 py-3 text-base font-semibold text-navy shadow transition hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-navy"
                    >
                        TRY AGAIN
                    </button>
                </div>
            </div>
        </main>
    );
};

ServerUnavailable.propTypes = {
    onRetry: PropTypes.func.isRequired,
};

export default ServerUnavailable;
